// Quick View Gallery Navigation Fix
// This must be defined globally before any Quick View opens

(function() {
  console.log('Loading Quick View gallery fix...');

  var qvState = {
    currentIndex: 0,
    images: [],
    initialized: false
  };

  // Store original bbGalleryNav if it exists
  var originalBbGalleryNav = window.bbGalleryNav;
  var originalBbSelectThumb = window.bbSelectThumb;

  // Override bbGalleryNav to work in both Quick View and regular product page
  window.bbGalleryNav = function(direction) {
    console.log('bbGalleryNav called, direction:', direction);

    // Check if we're in Quick View modal
    var modal = document.getElementById('PopupModal-quickview');
    var isQVOpen = modal && (modal.classList.contains('animate') || modal.hasAttribute('open'));

    if (isQVOpen) {
      console.log('Quick View is open, using QV navigation');
      var mainImg = modal.querySelector('.bb-gallery__main-img');

      if (!mainImg) {
        console.log('ERROR: Main image not found');
        return;
      }

      // Initialize images array if needed
      if (!qvState.initialized || qvState.images.length === 0) {
        console.log('Initializing QV images...');
        qvState.images = [];

        // Try to get images from thumbnails (they're hidden but exist in DOM)
        var thumbs = modal.querySelectorAll('.bb-gallery__thumb img');
        console.log('Found', thumbs.length, 'thumbnail images');

        if (thumbs.length > 0) {
          thumbs.forEach(function(img) {
            var largeSrc = img.src.replace('200x200', '1200x1200');
            qvState.images.push(largeSrc);
            console.log('Added image:', largeSrc);
          });
        } else {
          // Fallback: just use current image
          console.log('No thumbs found, using main image only');
          qvState.images.push(mainImg.src);
        }

        qvState.initialized = true;
        qvState.currentIndex = 0;
        console.log('Total images:', qvState.images.length);
      }

      // Navigate
      qvState.currentIndex += direction;

      // Wrap around
      if (qvState.currentIndex < 0) {
        qvState.currentIndex = qvState.images.length - 1;
      }
      if (qvState.currentIndex >= qvState.images.length) {
        qvState.currentIndex = 0;
      }

      console.log('Showing image index:', qvState.currentIndex);
      mainImg.src = qvState.images[qvState.currentIndex];

    } else {
      console.log('Regular page, using original function');
      // Call original function if it exists
      if (typeof originalBbGalleryNav === 'function') {
        originalBbGalleryNav(direction);
      }
    }
  };

  // Also override bbSelectThumb for thumbnail clicks
  window.bbSelectThumb = function(index) {
    var modal = document.getElementById('PopupModal-quickview');
    var isQVOpen = modal && (modal.classList.contains('animate') || modal.hasAttribute('open'));

    if (isQVOpen) {
      console.log('QV bbSelectThumb called with index:', index);
      var mainImg = modal.querySelector('.bb-gallery__main-img');

      if (!qvState.initialized || qvState.images.length === 0) {
        // Initialize first
        window.bbGalleryNav(0);
      }

      if (mainImg && qvState.images[index]) {
        qvState.currentIndex = index;
        mainImg.src = qvState.images[index];
      }
    } else {
      // Call original
      if (typeof originalBbSelectThumb === 'function') {
        originalBbSelectThumb(index);
      }
    }
  };

  // Reset state when modal closes
  function setupModalObserver() {
    var modal = document.getElementById('PopupModal-quickview');
    if (!modal) {
      console.log('Modal not found yet, will retry...');
      setTimeout(setupModalObserver, 500);
      return;
    }

    console.log('Setting up modal observer');
    var observer = new MutationObserver(function(mutations) {
      var isOpen = modal.classList.contains('animate') || modal.hasAttribute('open');

      if (!isOpen && qvState.initialized) {
        console.log('Modal closed, resetting QV state');
        qvState.initialized = false;
        qvState.images = [];
        qvState.currentIndex = 0;
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });
  }

  // Start observer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupModalObserver);
  } else {
    setupModalObserver();
  }

  console.log('Quick View gallery fix loaded successfully');
})();
